/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable indent */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */
/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/default-param-last */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-throw-literal */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';
import styled from 'styled-components';
import { ContentType } from '../enums/ContentType';
import {
  AISummaryButton,
  AISummarySource
} from '../features/ai_summary';
import { ContentSearchResult } from '../models/ContentSearchResult';
import { PeriodicListItem } from '../pages/pesquisa/components/list-items/PeriodicListItem';
import { ArticleListItem } from './ArticleListItem';
import { BookListItem } from './BookListItem';
import { ChapterListItem } from './ChapterListItem';
import { CodeListItem } from './CodeListItem';
import { DefaultContentListItem } from './DefaultContentListItem/DefaultContentListItem';
import { VideoListItem } from './VideoListItem';
import { LegislationListItem } from './LegislationListItem';
import { InformativeCoverListItem } from './InformativeCoverListItem';

interface IProps {
  result: ContentSearchResult;
  otherProps?: object;
}

const SummaryRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 0.75rem;
  width: 100%;

  > :first-child {
    flex: 1;
    min-width: 0;
  }

  .ai-summary-side {
    display: flex;
    align-items: center;
  }
`;

function getAISummarySource(
  result: ContentSearchResult
): AISummarySource | null {
  if (!result.parentId || !result.editionId) return null;

  if (result.contentType === ContentType.CHAPTER) {
    const chapterId = result.chapterId || result.id;
    if (!chapterId) return null;
    return {
      kind: 'book',
      bookId: result.parentId,
      editionId: result.editionId,
      chapterId
    };
  }

  if (result.contentType === ContentType.ARTICLE) {
    if (!result.id) return null;
    return {
      kind: 'periodic',
      periodicId: result.parentId,
      editionId: result.editionId,
      itemId: result.id
    };
  }

  return null;
}

export const SearchResultItemRenderer = ({
  result,
  otherProps = {}
}: IProps) => {
  const _props = {
    ...otherProps,
    result
  };

  const renderItem = () => {
    switch (result.contentType) {
      case ContentType.CHAPTER:
        return <ChapterListItem {..._props} />;
      case ContentType.ARTICLE:
        return <ArticleListItem {..._props} />;
      case ContentType.PERIODIC:
        return <PeriodicListItem {..._props} />;
      case ContentType.BOOK:
        return <BookListItem {..._props} />;
      case ContentType.LEGISLATION:
        return <LegislationListItem {..._props} />;
      case ContentType.VIDEO:
        return <VideoListItem {..._props} />;
      case ContentType.CODE_ITEM:
      case ContentType.CODE:
        return <CodeListItem {..._props} />;
      case ContentType.INFORMATIVE:
        return <InformativeCoverListItem {..._props} />;
      default:
        return <DefaultContentListItem {..._props} />;
    }
  };

  const summarySource = getAISummarySource(result);
  const itemNode = renderItem();

  if (!summarySource) return itemNode;

  return (
    <SummaryRow>
      {itemNode}
      <div className="ai-summary-side">
        <AISummaryButton source={summarySource} variant="inline" />
      </div>
    </SummaryRow>
  );
};
